<template>
  <div class="bp-icon" :style="componentStyle">
    <slot>
      <i :class="icon" :style="iconStyle" />
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 16
    },
    icon: {
      type: String,
      default: "fa-light fa-plus"
    },
    weight: {
      type: [String, Number],
      default: ""
    }
  },
  computed: {
    componentStyle() {
      const sizes = {
        12: 16,
        14: 20,
        16: 24,
        18: 24,
        20: 28,
        22: 32,
        24: 36,
        26: 36,
        32: 48,
        38: 56,
        50: 72
      };
      const size = sizes[this.size] || 24;
      return {
        width: size + "px",
        height: size + "px"
      };
    },
    iconStyle() {
      return {
        fontSize: this.size + "px",
        fontWeight: this.weight
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 16px;
  height: 16px;
}
</style>
